/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosLink } from "@components/elements/atoms";
import { useMessages } from "@epic-mw/i18n";
import { useRouter, useSearchParams } from "next/navigation";
import { MouseEventHandler, useCallback } from "react";
import { AuthBoxProps } from "./AuthBox";
import { linkStyles } from "./AuthBox.styles";
import { sanitizeRedirectURL } from "./AuthBox.utils";

export const AuthBack = (props: AuthBoxProps): React.JSX.Element => {
	const messages = useMessages();
	const router = useRouter();
	const searchParams = useSearchParams();
	const origin = props.origin;
	const state = searchParams.get("state") || "";

	const sanitizedState = sanitizeRedirectURL(state, props.origin);
	const onGoBackClick: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement> = useCallback(
		(e) => {
			e.preventDefault();
			if (sanitizedState) {
				//only one can cause a redirect loop
				router.back();
				router.back();
			} else {
				window.location.href = origin;
			}
		},
		[router, sanitizedState, origin],
	);

	return (
		<CosmosLink
			href={origin}
			className={linkStyles}
			onClick={onGoBackClick}
			analytics={{
				eventCategory: "hyperlink",
				eventLabel: messages["epic.cosmos.auth.back"] || "",
				eventValue: {
					component: "AuthBox",
				},
			}}
		>
			{messages["epic.cosmos.auth.back"]}
		</CosmosLink>
	);
};
